import InvestorGoalError from './InvestorGoalError';
class InvestorGoalNotFound extends InvestorGoalError {
    constructor(options) {
        super('The goal was not found', options);
    }
}
export default InvestorGoalNotFound;
